import { ContactMessage } from "../contact-models/ContactMessage";

export class ContactService {
    
    
    messages: ContactMessage[];
    
    getAllMessagesFromServer(){
        
    }
    
    addMessage(newMessage: ContactMessage) {
        console.log("message à ajouter");
    }
}
